import { useState } from 'react';
import { ScrollLock } from '@libs';
import { MODAL_ROOT, MODAL_TIMEOUT } from '@constants/params';

export const useModal = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const rootElement = typeof document !== 'undefined' ? document.querySelector(MODAL_ROOT) : null;

  const openModal = (hash) => {
    ScrollLock.lock(rootElement);
    setIsOpenModal(true);

    if (hash) {
      window.location.hash = hash;
    }
  };

  const closeModal = () => {
    setIsOpenModal(false);

    if (window.location.hash) {
      window.history.pushState('', document.title, window.location.pathname);
    }

    setTimeout(() => {
      ScrollLock.unlock(rootElement);
    }, MODAL_TIMEOUT);
  };

  return [isOpenModal, openModal, closeModal];
};
